import {
  Button,
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TableHead from "@mui/material/TableHead";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { assignArbitratorAssignment } from "../../adapter/assignmentAdapter";
import Loader from "../../components/Loader";

function Assignment(props) {
  const [responseData, setResponseData] = React.useState(props.data);
  const [loading, setloading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [isApiCallInProgress, setApiCallInProgress] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const assign = () => {
    if (isApiCallInProgress) {
      console.log("API call is already in progress. Please wait.");
      return;
    }
    setApiCallInProgress(true);
    setloading(true);
    const response = assignArbitratorAssignment({
      ...props.data,
      status: "assigned",
    });
    response.then((response) => {
      setloading(false);
      setOpen(false);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Arbitrator successfully assigned ",
        showConfirmButton: true,
      }).then(() => {
        navigate("/app/assignments");
      });
    });
    response.finally(() => {
      setApiCallInProgress(false);
    });
  };

  const navigate = useNavigate();

  const handleBack = () => {
    props.changeStep(1);
  };

  if (!responseData || responseData.length === 0) {
    return <Loader loading={loading} />;
  }

  return (
    <div className="container">
      <h2 className="component-title">Assign Arbitrator</h2>

      <div>
        <div variant="outlined" className="custom-card">
          <CardContent>
            <div className="card-header">
              <div className="card-sub-header">
                <p>
                  Assignment ID :{" "}
                  <span className="sub-text">{responseData.assignmentId}</span>
                </p>
              </div>
            </div>
            <TableContainer
              component={Paper}
              className="custom-table-container"
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell>Batch Id</TableCell>
                    <TableCell>
                      <span className="sub-text">{responseData.batchId}</span>
                    </TableCell>
                    <TableCell className="column-border">
                      Enterprise Name
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.enterpriseName}
                      </span>
                    </TableCell>
                    <TableCell className="column-border">
                      Nature of Dispute
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.natureOfDispute}
                      </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>No. of Cases</TableCell>
                    <TableCell>
                      <span className="sub-text">{responseData.noOfCases}</span>
                    </TableCell>{" "}
                    <TableCell className="column-border">Complexity</TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.complexity}
                      </span>
                    </TableCell>
                    <TableCell className="column-border">
                      Average Claim Value
                    </TableCell>
                    <TableCell>
                      <span className="sub-text">
                        {responseData.maxClaimValue}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </div>
        <div>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Sr No.</TableCell>
                  <TableCell align="center">Arbitrator Id</TableCell>
                  <TableCell align="center">Cases To Be Assigned</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {responseData &&
                  responseData.data &&
                  responseData.data.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell align="center">{row.pseudonym}</TableCell>
                      <TableCell align="center">{row.casesAssigned}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="formButtons-block">
            <Button
              style={{
                background:
                  "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
              }}
              type="submit"
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              onClick={handleBack}
            >
              Change
            </Button>
            <Button
              className="custom-button"
              type="submit"
              variant="contained"
              sx={{ mt: 2, mb: 2 }}
              onClick={handleClickOpen}
            >
              Confirm
            </Button>
          </div>
        </div>
        {open && (
          <Dialog open={open} onClose={handleClose}>
            <DialogContent>
              <DialogContentText>
                Please check the Arbitrator List before Confirming the
                Assignment of Arbitrators
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                className="custom-button"
                type="submit"
                variant="contained"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="custom-button"
                type="submit"
                variant="contained"
                onClick={assign}
              >
                Assign
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </div>
  );
}

export default Assignment;
